import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "../../utils";
import DetailsHandlerDef from "../../details/DetailsHandlerDef";
import icons from "../../resources/icons";
export default Class(DetailsHandlerDef, {
  initialize: function initialize(options) {
    var isMore = true;
    var buttonImage = icons.searchers.cvr;

    if (typeof options !== 'undefined') {
      if (typeof options.more !== 'undefined') isMore = options.more;
      if (options.buttonImage) buttonImage = options.buttonImage;
    }

    var myOptions = {
      buttonText: "CVR-info",
      buttonImage: buttonImage,
      handler: this.myHandler,
      isApplicable: function isApplicable(result) {
        return result.source === "cvr" && result.type === "Virksomhed";
      },
      more: isMore
    };
    DetailsHandlerDef.prototype.initialize.apply(this, [myOptions]);
  },
  myHandler: function () {
    var _myHandler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var items, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];
              url = "http://datacvr.virk.dk/data/visenhed?enhedstype=produktionsenhed&id=" + result.data.fields.pnr[0];
              items.push({
                type: 'link',
                icon: this.more ? this.buttonImage : icons.details.link,
                link: url,
                linkTitle: "Se CVR-info på virk.dk"
              });
              return _context.abrupt("return", items);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function myHandler(_x) {
      return _myHandler.apply(this, arguments);
    }

    return myHandler;
  }(),
  CLASS_NAME: 'Septima.Search.CvrLinkHandler'
});